import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { catchError, tap } from 'rxjs/operators'
import { saveAs } from 'file-saver'
import { PrintData, PrintSettings } from '@app/shared/models/print.model'
import { Observable, of } from 'rxjs'
import { NotificationService } from '@app/core/services/notification.service'

@Injectable({
  providedIn: 'root',
})
export class PrintHttpService {
  constructor(
    private http: HttpClient,
    private notificationService: NotificationService,
  ) {}

  getPrintSettings(projectId: string, ahuId: string) {
    return this.http.get<PrintSettings>(`./Api/project/${projectId}/print/${ahuId}`)
  }

  printDocument(projectId: string, fileName: string, data: PrintData): Observable<Blob> {
    return this.http.post(`./Api/project/${projectId}/print/`, data, { responseType: 'blob' }).pipe(
      tap({
        next: response => {
          saveAs(response, fileName)
        },
      }),
      catchError(() => {
        this.notificationService.error('UI.Error.Print')
        return of(null)
      }),
    )
  }
}
